import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { metaReducers, reducers } from './reducers';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../../environments/environment';
import { AuthStoreModule } from './auth/auth-store.module';
import { CoreStoreModule } from './core/core-store.module';
import { ReportsStoreModule } from './reports/reports-store.module';
import { UnitsStoreModule } from './units/units-store.module';
import { FuelCardStoreModule } from './fuel-card/fuel-card-store.module';
import { ZonesStoreModule } from './zones/zones-store.module';
import { UserAccountsStoreModule } from './user-accounts/user-accounts-store.module';
import { MapDrawStoreModule } from './map/map-draw-store.module';

@NgModule({
  imports: [
    StoreModule.forRoot(reducers, {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true
      }
    }),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: !environment.production,
      autoPause: true
    }),
    CoreStoreModule,
    AuthStoreModule,
    ReportsStoreModule,
    UnitsStoreModule,
    FuelCardStoreModule,
    ZonesStoreModule,
    UserAccountsStoreModule,
    MapDrawStoreModule
  ]
})
export class StoresModule {
}
